export default function AnalyticsError({ errorMsg, textStyle = { maxWidth: "100%" } }) {
  return (
    <div className="text text-danger" style={{ ...textStyle, ...{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } }}>
      {errorMsg}
    </div>
  );
}
